import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppointmentService } from '../../../business-services/appointment.service';
import { CookieService } from 'ngx-cookie-service';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { MultiStackPopupService } from '../../../services/multi-stack-popup.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { AppointmentRequestModel } from '../../../business-entities/appointmentList-model';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Component({
  selector: 'app-sync-fail-appointment',
  templateUrl: './sync-fail-appointment.component.html',
  styleUrl: './sync-fail-appointment.component.css'
})
export class SyncFailAppointmentComponent implements OnInit {
  appointmentList:any;
  userRoleRightsDetails: UserRoleMenu;
  UserList: Array<any>;
  currentLang:string;
  totalCount: any = 0;
  debounceTimer:any;
  searchTerm:string = '';
  appointmentRequestModel: AppointmentRequestModel =
  {
    appointmentStatusId: null,
    workOrderStatusId: null,
    bookingDate: null,
    createdDate: null,
    dealerId: null,
    serviceAdvisorId:null,
    isAuthorizedByServiceAdvisor: false,
    mechanicId:null,
    brandCode : null,
    searchTerm: null,
    startRecordNumber: 0,
    pageSize: 0,
    sortColumn: "",
    sortDirection: "",
    appointmentType:"",
    documentPartStatus: null,
    sourceOfCreation: '',
    isFilterUnRepliedMessages: false,
    isWarrantyAppointment: 0,
    customerName: null,
    mobileNumber: null,
    woNumber: null,
    licensePlate: null,
    isCampaignService: null,
    isTireHotel: null
  };
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    public translate: TranslateService,
    private readonly appointmentService: AppointmentService,
    private readonly cookieservice: CookieService,
    private readonly userService: UserDataService,
    private readonly spinner: NgxSpinnerService,
    private readonly multiStackPopupService: MultiStackPopupService,
    private readonly modalService: NgbModal,
    private readonly toastr: ToastrService
  ){}

  ngOnInit(): void {
    if (this.isCookiesExist()) {
      this.currentLang = this.cookieservice.get('userSelectedLanguage');
    } else {
      this.currentLang = EnvSetting.LANGUAGE_CONFIG.defaultLanguage;
    }
    this.appointmentRequestModel.languageCode = this.currentLang;
    this.appointmentRequestModel.startRecordNumber = 0;
    this.GetSyncFailAppointmentList();
  }

  private isCookiesExist(): boolean {
    return this.cookieservice.check('userSelectedLanguage');
  }

  async GetSyncFailAppointmentList() {
    this.spinner.show();
    this.appointmentRequestModel.searchTerm = this.searchTerm;
    this.totalCount = 0;
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Appointment);
    await this.appointmentService.GetSyncFailAppointmentList(this.appointmentRequestModel).then(res => {
      if (res) {
        if (res?.responseObject) {
          this.appointmentList = res?.responseObject.appointmentList;
          if(this.appointmentList != undefined){
            this.totalCount = this.appointmentList.length;
          }
          this.spinner.hide();
        }
      }
      else{
        this.spinner.hide();
      }
    })
  }

  OpenEditView(appointment:any){
    this.multiStackPopupService.OpenAppointment(appointment.id);
  }

  CreateAppointment(appointment:any,mymodal:any){
    this.modalService.open(mymodal, { size: 'md', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    }, (reason) => {
      if(reason){
        this.appointmentService.UpdateSyncFailAppointment(appointment.id).then(res =>{
          if(res){
            let activateAppointment = this.translate.instant("lblAppointmentRestored");
            this.toastr.success(activateAppointment);
            this.GetSyncFailAppointmentList();
          }
          else{
            this.spinner.hide();
          }
        })
      }  
    });
  }

  async onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.appointmentRequestModel.sortColumn = direction ? column : '';
    this.appointmentRequestModel.sortDirection = direction;
    this.appointmentRequestModel.startRecordNumber = 0;
    this.appointmentRequestModel.languageCode = this.currentLang;

    this.appointmentList = [];
    await this.GetSyncFailAppointmentList();
  }

  onEnterPress() {
    this.debounceFunction(() => this.GetSyncFailAppointmentList(), 500);
  }

  debounceFunction(func, delay) {
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }

}
